import {
  CHALLENGES,
  CUSTOMIZATION,
  GAME_RATING,
  GAMES,
  INTERACTIVE_SHOP,
  MAIN,
  RATING,
  TASK,
} from '../../../shared/states/names';

export const NAVIGATION_STATES = [MAIN, GAMES, RATING, TASK, CUSTOMIZATION, GAME_RATING, INTERACTIVE_SHOP, CHALLENGES];
